export function copyDocumentStyles(sourceDocument: Document, targetDocument: Document): void {
    if (!sourceDocument) {
        return;
    }

    if (!targetDocument) {
        return;
    }

    Array.from(sourceDocument.styleSheets).forEach((value: StyleSheet, index: number, array: StyleSheet[]) => {
        let styleSheet = value as CSSStyleSheet;
        if (styleSheet.cssRules) {
            const newStyleEl: HTMLStyleElement = sourceDocument.createElement("style");

            Array.from(styleSheet.cssRules).forEach((cssRule: CSSRule) => {
                newStyleEl.appendChild(sourceDocument.createTextNode(cssRule.cssText));
            });

            targetDocument.head.appendChild(newStyleEl);
        }
        else if (styleSheet.href) {
            const newLinkEl: HTMLLinkElement = sourceDocument.createElement("link");

            newLinkEl.rel = 'stylesheet';
            newLinkEl.href = styleSheet.href;

            targetDocument.head.appendChild(newLinkEl);
        }
    });
}

export function copyDocumentStylesLegacy(sourceDocument: Document, targetDocument: Document) {

    const styleTags = sourceDocument.head.getElementsByTagName("style");
    const linkTags = sourceDocument.head.getElementsByTagName("link");

    for (let i = 0; i < linkTags.length; i++) {
        if (linkTags.item(i).rel.toLocaleLowerCase() == "stylesheet") {
            const newLinkEl: HTMLLinkElement = sourceDocument.createElement("link");

            newLinkEl.rel = 'stylesheet';
            newLinkEl.href = linkTags.item(i).href;

            targetDocument.head.appendChild(newLinkEl);
        }

    }

    for (let i = 0; i < styleTags.length; i++) {

        const newStyleEl: HTMLStyleElement = sourceDocument.createElement("style");
        newStyleEl.appendChild(sourceDocument.createTextNode(styleTags.item(i).innerHTML));

        targetDocument.head.appendChild(newStyleEl);
    }
}

export function copyDocumentStylesToString(sourceDocument: Document): string {

    const styleTags = sourceDocument.head.getElementsByTagName("style");
    const linkTags = sourceDocument.head.getElementsByTagName("link");

    let output = "";

    for (let i = 0; i < linkTags.length; i++) {
        if (linkTags.item(i).rel.toLocaleLowerCase() == "stylesheet") {
            const newLinkEl: HTMLLinkElement = sourceDocument.createElement("link");

            newLinkEl.rel = 'stylesheet';
            newLinkEl.href = linkTags.item(i).href;

            output += newLinkEl.outerHTML;
        }

    }

    for (let i = 0; i < styleTags.length; i++) {

        const newStyleEl: HTMLStyleElement = sourceDocument.createElement("style");
        newStyleEl.appendChild(sourceDocument.createTextNode(styleTags.item(i).innerHTML));

        output += newStyleEl.outerHTML;
    }

    return output;
}